import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TranslationModuleEnum } from 'src/app/utils/translation-modules.enum';

@Component({
  selector: 'app-variables-dropdown',
  templateUrl: './variables-dropdown.component.html',
  styleUrls: ['./variables-dropdown.component.scss']
})
export class VariablesDropdownComponent implements OnInit {
  translationModulesEnum = TranslationModuleEnum;

  @Input() variables: any[];
  @Input() lang: string;
  @Output() variableSelected: EventEmitter<string> = new EventEmitter();

  showDropDown = false;

  @HostListener('document:click', ['$event']) onclick(evt: any) {
    if (!this.eRef.nativeElement.contains(evt.target)) {
      this.showDropDown = false;
    }
  }

  constructor(private eRef: ElementRef) { }

  ngOnInit(): void { }

  handleDropdown() {
    this.showDropDown = !this.showDropDown;
    window.dispatchEvent(new Event('resize'));
  }

  selectVariable(variable: any) {
    this.variableSelected.emit(variable.code);
    this.showDropDown = false;
  }
}
